import { render, staticRenderFns } from "./Registerp.vue?vue&type=template&id=d4881cde&scoped=true&"
import script from "./Registerp.vue?vue&type=script&lang=js&"
export * from "./Registerp.vue?vue&type=script&lang=js&"
import style0 from "./Registerp.vue?vue&type=style&index=0&id=d4881cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4881cde",
  null
  
)

export default component.exports